/**
 * Use `srOnly` to hide an element visually without hiding it from screen readers
 */
var srOnly = {
  position: 'absolute',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  height: '1px',
  width: '1px',
  margin: '-1px',
  padding: 0,
  border: 0
};
export var a11y = {
  srOnly: srOnly
};